// extracted by mini-css-extract-plugin
export default {"activateEmailContainer":"WBcvX","infotext":"xj8X8"};